/**
 * Utilitaire pour différer le CSS non-critique
 * Réduit le render-blocking et améliore FCP/LCP
 */

/**
 * Charge le CSS de manière asynchrone pour éviter le render-blocking
 */
export function loadDeferredCSS(href: string, media: string = 'all') {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.media = 'print'; // Charge sans bloquer
  
  link.onload = function() {
    link.media = media; // Applique après chargement
  };
  
  document.head.appendChild(link);
}

/**
 * Précharge les polices de manière optimisée
 */
export function preloadFonts() {
  const fonts = [
    {
      family: 'Orbitron',
      url: 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6BoWgz.woff2',
      weight: '400 900'
    }
  ];
  
  fonts.forEach(font => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.crossOrigin = 'anonymous';
    link.href = font.url;
    
    document.head.appendChild(link);
  });
}

/**
 * Inline le CSS critique pour éliminer le render-blocking
 */
export function inlineCriticalCSS() {
  const criticalCSS = `
    /* Reset minimal */
    *,::before,::after{box-sizing:border-box;border:0 solid}
    html{line-height:1.5;-webkit-text-size-adjust:100%;tab-size:4;font-family:ui-sans-serif,system-ui,-apple-system,sans-serif}
    body{margin:0;line-height:inherit}
    
    /* Layout de base pour éviter CLS */
    body{min-height:100vh;background:#020617}
    #root{min-height:100vh}
    
    /* Header fixe pour éviter layout shift */
    header{min-height:80px}
    
    /* Images - réserver espace */
    img{height:auto;max-width:100%;display:block}
    img:not([width]):not([height]){aspect-ratio:attr(width)/attr(height)}
    
    /* Polices avec fallback system */
    body{font-family:'Orbitron',ui-sans-serif,system-ui,-apple-system,sans-serif}
    
    /* Couleurs critiques */
    .bg-slate-950{background-color:rgb(2 6 23)}
    .bg-slate-900{background-color:rgb(15 23 42)}
    .text-white{color:rgb(255 255 255)}
    
    /* Éviter FOUC */
    .loading-placeholder{
      background:linear-gradient(90deg,#1e293b 0%,#334155 50%,#1e293b 100%);
      background-size:200% 100%;
      animation:shimmer 1.5s infinite;
    }
    @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
  `;
  
  const style = document.createElement('style');
  style.id = 'critical-inline-css';
  style.textContent = criticalCSS;
  document.head.insertBefore(style, document.head.firstChild);
}

/**
 * Optimise le chargement des ressources
 */
export function optimizeResourceLoading() {
  // Inline le CSS critique
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inlineCriticalCSS);
  } else {
    inlineCriticalCSS();
  }
  
  // Précharger les polices
  preloadFonts();
  
  // Différer les scripts non-critiques
  const scripts = document.querySelectorAll('script[src]:not([async]):not([defer])');
  scripts.forEach((script: Element) => {
    const scriptElement = script as HTMLScriptElement;
    // Ne pas différer le script principal de l'app
    if (!scriptElement.src.includes('/src/main.tsx') && !scriptElement.src.includes('gtag')) {
      scriptElement.defer = true;
    }
  });
}
